import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const ProjectCard = ({ project }) => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <div
      className={`project-card ${isVisible ? 'scroll-animate in-view' : 'scroll-animate'}`}
      ref={ref}
    >
      <div className="project-number">{project.number}</div>
      <h3>{project.title}</h3>
      <p className="project-subtitle">{project.subtitle}</p>
      <p>{project.description}</p>
    </div>
  );
};

const Projects = () => {
  const projects = [
    {
      number: '01',
      title: 'E-PROD',
      subtitle: 'Medição Individual de Performance Integrada',
      description: 'Sistema completo para avaliação e acompanhamento de performance individual com métricas precisas e relatórios detalhados.'
    },
    {
      number: '02',
      title: 'SIGMA',
      subtitle: 'Sistema Integrado de Gestão de Materiais',
      description: 'Plataforma completa para gerenciamento de estoque, controle de materiais e otimização de recursos.'
    },
    {
      number: '03',
      title: 'SEMED',
      subtitle: 'Sistema de Cadastro de Notas Fiscais',
      description: 'Sistema eficiente para cadastro, controle e gestão de notas fiscais com conformidade tributária.'
    },
    {
      number: '04',
      title: 'Assistente Virtual',
      subtitle: 'Chatbot em IA para Saúde',
      description: 'Assistente virtual inteligente para atendimento na área da saúde, oferecendo suporte 24/7 aos pacientes.'
    },
    {
      number: '05',
      title: 'Sistema de Gestão Educacional',
      subtitle: 'Sistemas para Educação com desempenho e avaliação',
      description: 'Plataforma completa com medição de performance individual, ferramentas especializadas para avaliação de fluência e habilidades de leitura, soluções voltadas para o setor educacional.'
    },
    {
      number: '06',
      title: 'Sistema de Gestão de Obra',
      subtitle: 'Gestão Completa para Construção Civil',
      description: 'Ferramenta direcionada para o setor de construção civil, facilitando o gerenciamento de projetos, recursos e cronogramas.'
    }
  ];

  return (
    <section className="projects" id="projects">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Nossos Projetos</span>
          <h2 className="section-title">
            Transformando <span className="gradient-text">desafios em soluções</span>
          </h2>
        </div>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <ProjectCard key={index} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;

